let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("7uY3Y")).then(() => parcelRequire('hhOn3'));